import styled from 'styled-components/macro';
import { COLORS, RIGHT_COLUMN_WIDTH } from 'styleguide';

const RightColumn = styled.div`
  position: sticky;
  top: 0;
  z-index: 4;
  flex: 0 0 ${RIGHT_COLUMN_WIDTH};
  width: ${RIGHT_COLUMN_WIDTH};
  height: 100vh;
  padding: 24px;
  border-left: 1px solid ${COLORS.line};
`;

export default RightColumn;
